import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { hasCommentingFeature } from '../utils/features';
import useCollaborationSidebarState from './useCollaborationSidebarState';
export default function useHasCommentingFeature() {
  "use memo";

  const $ = _c(2);
  const {
    enabledFeatures
  } = useCollaborationSidebarState();
  let t0;
  let t1;
  if ($[0] !== enabledFeatures) {
    t1 = hasCommentingFeature(enabledFeatures);
    $[0] = enabledFeatures;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  return t0;
}